import { namespace, Logger, Distance } from '../../../../../../FrontendBundle/Resources/js/ofcs';
import MoveItemsCommand from '../../command/moveItemsCommand';
import RotateHandle from './rotateHandle';

/**
 * Represents the rotate handle on a svg canvas.
 *
 * @class   Ofcs.Editor.Svg.Handle.RotateHandleTabletop
 * @extends Ofcs.Editor.Svg.Handle.RotateHandle
 */
export default class RotateHandleTabletop extends RotateHandle {
    /**
     * Callback method which is called when dragging of pointer ends
     *
     * @protected
     * @param {Object} event Drag event. See CanvasDraggable#drag
     */
    onPointerDragStop(event) {
        Logger.debug('rotateStop tabletop', event);

        this.elementScale.hide();
        this.draggin = false;

        this.updateElementsPositions();

        // move tableleg to trigger insideTabletopManager
        const command = new MoveItemsCommand(
            this.item,
            new Distance(0, 0),
        );
        this.canvas.getCommandExecutor().execute(command);

        this.canvas.getHistory().addCommand(this.command);
        delete this.command;
    }
}

namespace('Ofcs.Editor.Svg.Handle');
window.Ofcs.Editor.Svg.Handle.RotateHandleTabletop = RotateHandleTabletop;
